export const Theme_Mode_Light = "light" as const;
export const Theme_Mode_Dark = "dark" as const;

export type Theme_Mode = typeof Theme_Mode_Light | typeof Theme_Mode_Dark;

export const Theme_Modes: Theme_Mode[] = [Theme_Mode_Light, Theme_Mode_Dark];

export const Theme_Storage_Key = "ParcelQ_Theme";
